import { Helpers } from '../../helpers';
import { IGeneralAttribute } from '../../interfaces/igeneral-attribute';
import { GeneralAttributeRateKey } from '../general-attribute-rate-key';
import { GeneralAttributeResourceCalculationKey } from '../general-attribute-resource-calculation-key';

export class GeneralAttributeBase {
  GeneralAttributeId: number;
  Name: string;
  Value: string;
  LastUpdatedDate: Date;
  LastUpdatedUser: string;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  GeneralAttributeRateKeys_GeneralAttribute?: Array<GeneralAttributeRateKey> | null;
  GeneralAttributeResourceCalculationKeys_GeneralAttribute?: Array<GeneralAttributeResourceCalculationKey> | null;

  constructor(item?: IGeneralAttribute) {
    if (item) {

      this.GeneralAttributeId = item.GeneralAttributeId;
      this.Name = item.Name;
      this.Value = item.Value;
      this.LastUpdatedDate = item.LastUpdatedDate ? new Date(item.LastUpdatedDate) : null;
      this.LastUpdatedUser = item.LastUpdatedUser;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.GeneralAttributeRateKeys_GeneralAttribute = Helpers.createClassArray(GeneralAttributeRateKey, item.GeneralAttributeRateKeys_GeneralAttribute);
      this.GeneralAttributeResourceCalculationKeys_GeneralAttribute = Helpers.createClassArray(GeneralAttributeResourceCalculationKey, item.GeneralAttributeResourceCalculationKeys_GeneralAttribute);
    }
  }
}